module.exports = __webpack_public_path__ + "img/39-800x800.e2df5819.jpg";